// extracted by mini-css-extract-plugin
module.exports = {"root":"Highlighted_root__107pv","highlight":"Highlighted_highlight__1k5xt"};